module.exports = __webpack_public_path__ + "static/img/cd4518be-1.d52b202.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/cd4518be-1.svg
// module id = u7bN
// module chunks = 0